import React from "react";
import { Dropdown } from "@fluentui/react";
import { Wrapper } from "./ui";
import { numbers, types } from "./utils";

interface IPeriod {
  number: number;
  type: string;
  onChangeNumber: (number: number) => void;
  onchangeType: (type: string) => void;
}

const PastPeriod = ({ number, type, onChangeNumber, onchangeType }: IPeriod) => (
  <Wrapper>
    <Dropdown
      options={numbers}
      selectedKey={number}
      onChange={(_, n) => {
        onChangeNumber(n?.key as number);
      }}
    />
    <Dropdown
      options={types}
      selectedKey={type}
      onChange={(_, t) => {
        onchangeType(t?.key as string);
      }}
    />
  </Wrapper>
);

export default PastPeriod;
